import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';

export const listTargetAnswers =
  (payload) =>
    (dispatch) => {
      dispatch({
        type: REDUX_ACTIONS.TARGET_ANSWERS_LIST_LOADING,
      });

      const body = {
        input: {
          question: payload?.question,
          referenceCategory: payload?.referenceCategory
        }
      };

      const path = 'enverus/appTargetAnswers';
      return fetch
        .post(path, body)
        .then((resp) => {
          if (!resp.ok) {
            return Promise.reject(resp);
          }
          return resp.json();
        })
        .then((data) => {
          dispatch({
            type: REDUX_ACTIONS.TARGET_ANSWERS_LIST_SUCCESS,
            payload: {
              targetAnswers: data || [],
            },
          });
        })
        .catch(async (error) => {
          const errorMessage = await parseError(error);
          dispatch(
            enqueueSnackbar(
              errorMessage,
              'error',
              new Date().getTime() + Math.random()
            )
          );
          dispatch({
            type: REDUX_ACTIONS.TARGET_ANSWERS_LIST_ERROR,
            payload: { ...error, message: errorMessage },
          });
        });
    };
